import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { catchError, map, of } from "rxjs";
import { DtsService } from "./dts.service";

/**
 * `/drive-to-store` solo para las organizaciones con DTS habilitado.
 *
 * El backend decide (allowlist de organizaciones + super-admin) y la pestaña de campaña ya lo respetaba;
 * la página propia no, así que una organización sin acceso entraba y se comía un 403 en cada llamada.
 * Fail-closed como la pestaña: si `GET /enabled` falla, no se entra.
 */
export const dtsEnabledGuard: CanActivateFn = () => {
    const dts = inject(DtsService);
    const router = inject(Router);

    return dts.getEnabled().pipe(
        map(({ enabled }) => (enabled === true ? true : router.parseUrl("/"))),
        catchError(() => of(router.parseUrl("/")))
    );
};
